module.exports = __webpack_public_path__ + "img/state.c01dedc0.png";